module.exports = __webpack_public_path__ + "img/faq-interview.d2cd462c.svg";